(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pawomega-video-stories"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('pawomega-stories'))customElements.define('pawomega-stories',class extends HTMLElement{
    connectedCallback(){
      this.abort?.abort();this.abort=new AbortController();const opt={signal:this.abort.signal};
      const dialog=this.querySelector('dialog'),video=dialog.querySelector('video'),track=this.querySelector('.po-track');
      const close=()=>{video.pause();video.removeAttribute('src');video.load();this.querySelector('.po-error').hidden=true;};
      this.addEventListener('click',e=>{
        const play=e.target.closest('[data-po-video]');
        if(play){this.opener=play;dialog.querySelector('.po-dialog-title').textContent=play.dataset.poTitle;video.src=play.dataset.poVideo;video.poster=play.querySelector('img')?.src||'';dialog.showModal();video.play().catch(()=>{});}
        if(e.target.closest('.po-close')||e.target===dialog)dialog.close();
        const nav=e.target.closest('[data-po-direction]');if(nav)track.scrollBy({left:Number(nav.dataset.poDirection)*(track.querySelector('.po-card').offsetWidth+20),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      },opt);
      dialog.addEventListener('close',()=>{close();this.opener?.focus();},opt);
      video.addEventListener('error',()=>{this.querySelector('.po-error').hidden=false;},opt);
      this.update=()=>{const max=track.scrollWidth-track.clientWidth;this.querySelector('[data-po-direction="-1"]').disabled=track.scrollLeft<3;this.querySelector('[data-po-direction="1"]').disabled=track.scrollLeft>=max-3;};
      track.addEventListener('scroll',this.update,opt);this.observer=new ResizeObserver(this.update);this.observer.observe(track);this.update();
      document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();},opt);
    }
    disconnectedCallback(){this.querySelector('video')?.pause();this.abort?.abort();this.observer?.disconnect();}
  });

  } catch(e) { console.error(e); }
})();
})();
